var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.isChecked ? 'fdd-radioy-on' : 'fdd-radioy',on:{"click":_vm.handleClick}},[_c('i',{staticClass:"use-icon_radio"}),_c('span',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.labelText))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }